import { useQuery } from 'react-query';

import { Run } from '../../../types';
import { QueryEntity } from '../../types';
import useGetFetchConfig from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';

export const useFetchOrgActiveRuns = (orgId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Run[]>(
    [QueryEntity.ActiveRuns, orgId],
    async () => {
      const queryParams = new URLSearchParams({ orgId }).toString();
      try {
        const res = await fetch(`${APIBaseChronos}/api/org/runs?${queryParams}`, fetchConfigGET);
        return await res.json();
      } catch (err) {
        throw err;
      }
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
